import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=4ce55de7&scoped=true"
import script from "./Activation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Activation.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce55de7",
  null
  
)

export default component.exports